export interface StepItem {
  id: string;
  step: string;
  title: string;
  desc: string;
  icon: string;
}

export const howToSteps: StepItem[] = [
  {
    id: "s1",
    step: "01",
    title: "先定范围",
    desc: "在分类专区里勾一个你感兴趣的题材，或直接从合集里挑一份主题名单。",
    icon: "ri-filter-3-line",
  },
  {
    id: "s2",
    step: "02",
    title: "看标注再点",
    desc: "每条入口都标了更新时间与入口数量，优先点更新新的，避免打开就踩空。",
    icon: "ri-price-tag-3-line",
  },
  {
    id: "s3",
    step: "03",
    title: "不合适就退回",
    desc: "入口只是入口，不合口味直接回列表换下一条，不用在单个站里耗时间。",
    icon: "ri-arrow-go-back-line",
  },
  {
    id: "s4",
    step: "04",
    title: "顺榜单抄作业",
    desc: "懒得挑就照热度榜单从上往下点，前几名基本都经过一轮可访问性校验。",
    icon: "ri-trophy-line",
  },
];

export interface HeroStat {
  id: string;
  label: string;
  value: string;
  sub: string;
}

export const heroStats: HeroStat[] = [
  { id: "h1", label: "收录入口", value: "1,286", sub: "持续校验" },
  { id: "h2", label: "主题分类", value: "36", sub: "按类归好" },
  { id: "h3", label: "今日整理", value: "58", sub: "实时更新" },
];